import {FunctionComponent, SVGProps} from 'react';

import {Grid, SxProps, Typography} from '@mui/material';
import {Variant} from '@mui/material/styles/createTypography';
import {TypographyPropsVariantOverrides} from '@mui/material/Typography/Typography';
import {OverridableStringUnion} from '@mui/types';

import {ReactComponent as Smiley} from '../../../../../assets/company_benefits/smile.svg';
import {ReactComponent as BuildingColumns} from '../../../../../assets/job_postings/icons/building-columns.svg';
import {ReactComponent as Building} from '../../../../../assets/job_postings/icons/building.svg';
import {ReactComponent as Check} from '../../../../../assets/job_postings/icons/check.svg';
import {ReactComponent as Clock} from '../../../../../assets/job_postings/icons/clock.svg';
import {ReactComponent as Comment} from '../../../../../assets/job_postings/icons/comment.svg';
import {ReactComponent as Knowledge} from '../../../../../assets/job_postings/icons/knowledge.svg';
import {ReactComponent as MoneyBill} from '../../../../../assets/job_postings/icons/money-bill.svg';
import {ReactComponent as RemoteWork} from '../../../../../assets/job_postings/icons/remote.svg';
import {ReactComponent as Spa} from '../../../../../assets/job_postings/icons/spa.svg';

export enum JobDetailsIcon {
  MoneyBill,
  BuildingColumns,
  RemoteWork,
  Clock,
  Knowledge,
  Comment,
  Building,
  Check,
  Spa,
  Smiley,
}

const Icons: Record<JobDetailsIcon, FunctionComponent<SVGProps<SVGSVGElement> & {title?: string}>> = {
  [JobDetailsIcon.MoneyBill]: MoneyBill,
  [JobDetailsIcon.BuildingColumns]: BuildingColumns,
  [JobDetailsIcon.RemoteWork]: RemoteWork,
  [JobDetailsIcon.Clock]: Clock,
  [JobDetailsIcon.Knowledge]: Knowledge,
  [JobDetailsIcon.Comment]: Comment,
  [JobDetailsIcon.Building]: Building,
  [JobDetailsIcon.Check]: Check,
  [JobDetailsIcon.Spa]: Spa,
  [JobDetailsIcon.Smiley]: Smiley,
};

interface Props {
  iconColor: string;
  icon: JobDetailsIcon;
  text: string;
  textColor?: string;
  minWidth?: string;
  variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>;
  sx?: SxProps;
  size?: string;
}

export const IconHeader = ({
  text,
  textColor,
  icon,
  iconColor,
  minWidth = '18px',
  variant = 'body1',
  sx,
  size,
}: Props) => {
  const Icon = Icons[icon];
  return (
    <Grid
      item
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        ...sx,
      }}
    >
      <Icon fill={iconColor} style={{minWidth, ...(size && {width: size, height: size})}} />
      <Typography variant={variant} sx={{paddingLeft: '16px', ...(textColor && {color: textColor})}}>
        {text}
      </Typography>
    </Grid>
  );
};
